import { render, staticRenderFns } from "./ImageEdit.vue?vue&type=template&id=2056e1c8&scoped=true"
import script from "./ImageEdit.vue?vue&type=script&lang=js"
export * from "./ImageEdit.vue?vue&type=script&lang=js"
import style0 from "./ImageEdit.vue?vue&type=style&index=0&id=2056e1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056e1c8",
  null
  
)

export default component.exports